import { render, staticRenderFns } from "./LoaderPage.vue?vue&type=template&id=37f2dd0c&"
import script from "./LoaderPage.vue?vue&type=script&lang=js&"
export * from "./LoaderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports